module.exports = __webpack_public_path__ + "img/nudgd.d53a5856.png";